import { getApi } from '../../utils/api'

export function getMessageTemplates(params) {
  return getApi({
    endpoint: 'api/text-module/message-snippet/',
    params,
  })
}
